import C from "../../constants";

const initialState = {
  player: null,
  subtitles: [],
  speakers: [],
  recordingMeta: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
   
    case C.PLAYER: {
      let result = state;
      result.player = action.payload;
      return result;
    }

    case C.SUBTITLES: {
      let result = state;
      result.subtitles = action.payload;
      return result;
    }

    case C.SPEAKERS: {
      return {
        ...state,
        speakers: action.payload,
      };
    }

    case C.RECORDING_META: {
      return {
        ...state,
        recordingMeta: action.payload,
      };
    }


    default:
      return {
        ...state,
      };
  }
};

export default reducer;
